module.exports = {
	"contractName": "Fomo4DFactory",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "createInstance",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_instance",
					"type": "address"
				},
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "validateInstance",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "77:407:12:-;;;501:5:29;:18;;-1:-1:-1;;;;;;501:18:29;509:10;501:18;;;77:407:12;;;;;;",
	"deployedSourceMap": "77:407:12:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;113:117;;-1:-1:-1;;;;;113:117:12;;;;;;;;;-1:-1:-1;;;;;113:117:12;;;;;;;;;;;;;;238:20:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;238:20:29;;;;234:248:12;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;234:248:12;-1:-1:-1;;;;;234:248:12;;;;;;;;;;;;;;;;;;;;;;;;;;;;832:169:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;832:169:29;-1:-1:-1;;;;;832:169:29;;;;;;;113:117:12;178:7;213:12;;:::i;:::-;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;-1:-1;206:19:12;113:117;-1:-1:-1;;113:117:12:o;238:20:29:-;;;-1:-1:-1;;;;;238:20:29;;:::o;234:248:12:-;435:21;;;;;;;;;;;;;;;;414:16;;;;;320:4;;372:9;;435:21;;-1:-1:-1;;;;;414:14:12;;;;;:16;;;;;320:4;;414:16;;;;;;;320:4;414:14;:16;;;5:2:-1;;;;30:1;27;20:12;5:2;414:16:12;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;414:16:12;;;;;;39::-1;36:1;17:17;2:54;101:4;414:16:12;80:15:-1;;;-1:-1;;76:31;65:43;;120:4;113:20;13:2;5:11;;2:2;;;29:1;26;19:12;2:2;414:16:12;;;;;;20:11:-1;15:3;12:20;9:2;;;45:1;42;35:12;9:2;64:21;;126:4;117:14;;142:31;;;139:2;;;186:1;183;176:12;139:2;218:10;;268:11;251:29;;293:43;;;290:58;-1:-1;239:118;236:2;;;370:1;367;360:12;236:2;0:382;;414:16:12;;;;;;404:27;;;;;;;;;;;;;36:153:-1;66:2;58:11;;36:153;;176:10;;164:23;;-1:-1;;139:12;;;;98:2;89:12;;;;114;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;404:27:12;;;;;;;;;;;;;;;;:52;;;;:67;;466:5;404:67;;;459:4;404:67;389:88;234:248;-1:-1:-1;;;;234:248:12:o;832:169:29:-;653:5;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;-1:-1:-1;;;;;908:22:29;;;;900:31;;;;;;958:5;;;937:37;;-1:-1:-1;;;;;937:37:29;;;;958:5;;;937:37;;;980:5;:16;;-1:-1:-1;;980:16:29;-1:-1:-1;;;;;980:16:29;;;;;;;;;;832:169::o;77:407:12:-;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.24;\n\nimport \"./base/Level.sol\";\nimport \"./Fomo4D.sol\";\n\ncontract Fomo4DFactory is Level {\n  function createInstance(address _player) public payable returns (address) {\n    _player;\n    return new Fomo4D();\n  }\n\n  function validateInstance(address _instance, address _player)\n    public\n    returns (bool)\n  {\n    _player;\n    Fomo4D instance = Fomo4D(_instance);\n\n    return (\n      keccak256(instance.owner()) == keccak256(\"Bill Hsu\") ? true : false\n    );\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Fomo4DFactory.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Fomo4DFactory.sol",
		"exportedSymbols": {
			"Fomo4DFactory": [
				1343
			]
		},
		"id": 1344,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1292,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:12"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 1293,
				"nodeType": "ImportDirective",
				"scope": 1344,
				"sourceUnit": 2867,
				"src": "26:26:12",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Fomo4D.sol",
				"file": "./Fomo4D.sol",
				"id": 1294,
				"nodeType": "ImportDirective",
				"scope": 1344,
				"sourceUnit": 1291,
				"src": "53:22:12",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 1295,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "103:5:12",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 1296,
						"nodeType": "InheritanceSpecifier",
						"src": "103:5:12"
					}
				],
				"contractDependencies": [
					1290,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1343,
				"linearizedBaseContracts": [
					1343,
					2866,
					2922
				],
				"name": "Fomo4DFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 1309,
							"nodeType": "Block",
							"src": "187:43:12",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1303,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1298,
										"src": "193:7:12",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1304,
									"nodeType": "ExpressionStatement",
									"src": "193:7:12"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 1306,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "213:10:12",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$__$returns$_t_contract$_Fomo4D_$1290_$",
												"typeString": "function () returns (contract Fomo4D)"
											},
											"typeName": {
												"contractScope": null,
												"id": 1305,
												"name": "Fomo4D",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1290,
												"src": "217:6:12",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Fomo4D_$1290",
													"typeString": "contract Fomo4D"
												}
											}
										},
										"id": 1307,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "213:12:12",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Fomo4D_$1290",
											"typeString": "contract Fomo4D"
										}
									},
									"functionReturnParameters": 1302,
									"id": 1308,
									"nodeType": "Return",
									"src": "206:19:12"
								}
							]
						},
						"documentation": null,
						"id": 1310,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1299,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1298,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1310,
									"src": "137:15:12",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1297,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "137:7:12",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "136:17:12"
						},
						"payable": true,
						"returnParameters": {
							"id": 1302,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1301,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1310,
									"src": "178:7:12",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1300,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "178:7:12",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "177:9:12"
						},
						"scope": 1343,
						"src": "113:117:12",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1341,
							"nodeType": "Block",
							"src": "328:154:12",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1319,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1314,
										"src": "334:7:12",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1320,
									"nodeType": "ExpressionStatement",
									"src": "334:7:12"
								},
								{
									"assignments": [
										1322
									],
									"declarations": [
										{
											"constant": false,
											"id": 1322,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 1342,
											"src": "347:15:12",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Fomo4D_$1290",
												"typeString": "contract Fomo4D"
											},
											"typeName": {
												"contractScope": null,
												"id": 1321,
												"name": "Fomo4D",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1290,
												"src": "347:6:12",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Fomo4D_$1290",
													"typeString": "contract Fomo4D"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1326,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1324,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1312,
												"src": "372:9:12",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 1323,
											"name": "Fomo4D",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1290,
											"src": "365:6:12",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_Fomo4D_$1290_$",
												"typeString": "type(contract Fomo4D)"
											}
										},
										"id": 1325,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "365:17:12",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Fomo4D_$1290",
											"typeString": "contract Fomo4D"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "347:35:12"
								},
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													},
													"id": 1335,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"arguments": [],
																"expression": {
																	"argumentTypes": [],
																	"expression": {
																		"argumentTypes": null,
																		"id": 1328,
																		"name": "instance",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1322,
																		"src": "414:8:12",
																		"typeDescriptions": {
																			"typeIdentifier": "t_contract$_Fomo4D_$1290",
																			"typeString": "contract Fomo4D"
																		}
																	},
																	"id": 1329,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "owner",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 1240,
																	"src": "414:14:12",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_external_view$__$returns$_t_string_memory_$",
																		"typeString": "function () view external returns (string memory)"
																	}
																},
																"id": 1330,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "414:16:12",
																"typeDescriptions": {
																	"typeIdentifier": "t_string_memory",
																	"typeString": "string memory"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_string_memory",
																	"typeString": "string memory"
																}
															],
															"id": 1327,
															"name": "keccak256",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2931,
															"src": "404:9:12",
															"typeDescriptions": {
																"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
																"typeString": "function () pure returns (bytes32)"
															}
														},
														"id": 1331,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "404:27:12",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"hexValue": "42696c6c20487375",
																"id": 1333,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "string",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "445:10:12",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_stringliteral_4156829ec8b244eafa6496960410cb08d9ddde0f3f53499a381222d819b4359a",
																	"typeString": "literal_string \"Bill Hsu\""
																},
																"value": "Bill Hsu"
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_stringliteral_4156829ec8b244eafa6496960410cb08d9ddde0f3f53499a381222d819b4359a",
																	"typeString": "literal_string \"Bill Hsu\""
																}
															],
															"id": 1332,
															"name": "keccak256",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2931,
															"src": "435:9:12",
															"typeDescriptions": {
																"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
																"typeString": "function () pure returns (bytes32)"
															}
														},
														"id": 1334,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "435:21:12",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"src": "404:52:12",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseExpression": {
													"argumentTypes": null,
													"hexValue": "66616c7365",
													"id": 1337,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "466:5:12",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "false"
												},
												"id": 1338,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "Conditional",
												"src": "404:67:12",
												"trueExpression": {
													"argumentTypes": null,
													"hexValue": "74727565",
													"id": 1336,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "459:4:12",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "true"
												},
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"id": 1339,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "396:81:12",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 1318,
									"id": 1340,
									"nodeType": "Return",
									"src": "389:88:12"
								}
							]
						},
						"documentation": null,
						"id": 1342,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1315,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1312,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 1342,
									"src": "260:17:12",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1311,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "260:7:12",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1314,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1342,
									"src": "279:15:12",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1313,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "279:7:12",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "259:36:12"
						},
						"payable": false,
						"returnParameters": {
							"id": 1318,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1317,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1342,
									"src": "320:4:12",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1316,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "320:4:12",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "319:6:12"
						},
						"scope": 1343,
						"src": "234:248:12",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 1344,
				"src": "77:407:12"
			}
		],
		"src": "0:485:12"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Fomo4DFactory.sol",
		"exportedSymbols": {
			"Fomo4DFactory": [
				1343
			]
		},
		"id": 1344,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1292,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:12"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 1293,
				"nodeType": "ImportDirective",
				"scope": 1344,
				"sourceUnit": 2867,
				"src": "26:26:12",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Fomo4D.sol",
				"file": "./Fomo4D.sol",
				"id": 1294,
				"nodeType": "ImportDirective",
				"scope": 1344,
				"sourceUnit": 1291,
				"src": "53:22:12",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 1295,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "103:5:12",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 1296,
						"nodeType": "InheritanceSpecifier",
						"src": "103:5:12"
					}
				],
				"contractDependencies": [
					1290,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1343,
				"linearizedBaseContracts": [
					1343,
					2866,
					2922
				],
				"name": "Fomo4DFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 1309,
							"nodeType": "Block",
							"src": "187:43:12",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1303,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1298,
										"src": "193:7:12",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1304,
									"nodeType": "ExpressionStatement",
									"src": "193:7:12"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 1306,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "213:10:12",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$__$returns$_t_contract$_Fomo4D_$1290_$",
												"typeString": "function () returns (contract Fomo4D)"
											},
											"typeName": {
												"contractScope": null,
												"id": 1305,
												"name": "Fomo4D",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1290,
												"src": "217:6:12",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Fomo4D_$1290",
													"typeString": "contract Fomo4D"
												}
											}
										},
										"id": 1307,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "213:12:12",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Fomo4D_$1290",
											"typeString": "contract Fomo4D"
										}
									},
									"functionReturnParameters": 1302,
									"id": 1308,
									"nodeType": "Return",
									"src": "206:19:12"
								}
							]
						},
						"documentation": null,
						"id": 1310,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1299,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1298,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1310,
									"src": "137:15:12",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1297,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "137:7:12",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "136:17:12"
						},
						"payable": true,
						"returnParameters": {
							"id": 1302,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1301,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1310,
									"src": "178:7:12",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1300,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "178:7:12",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "177:9:12"
						},
						"scope": 1343,
						"src": "113:117:12",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1341,
							"nodeType": "Block",
							"src": "328:154:12",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1319,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1314,
										"src": "334:7:12",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1320,
									"nodeType": "ExpressionStatement",
									"src": "334:7:12"
								},
								{
									"assignments": [
										1322
									],
									"declarations": [
										{
											"constant": false,
											"id": 1322,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 1342,
											"src": "347:15:12",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Fomo4D_$1290",
												"typeString": "contract Fomo4D"
											},
											"typeName": {
												"contractScope": null,
												"id": 1321,
												"name": "Fomo4D",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1290,
												"src": "347:6:12",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Fomo4D_$1290",
													"typeString": "contract Fomo4D"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1326,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1324,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1312,
												"src": "372:9:12",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 1323,
											"name": "Fomo4D",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1290,
											"src": "365:6:12",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_Fomo4D_$1290_$",
												"typeString": "type(contract Fomo4D)"
											}
										},
										"id": 1325,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "365:17:12",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Fomo4D_$1290",
											"typeString": "contract Fomo4D"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "347:35:12"
								},
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													},
													"id": 1335,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"arguments": [],
																"expression": {
																	"argumentTypes": [],
																	"expression": {
																		"argumentTypes": null,
																		"id": 1328,
																		"name": "instance",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1322,
																		"src": "414:8:12",
																		"typeDescriptions": {
																			"typeIdentifier": "t_contract$_Fomo4D_$1290",
																			"typeString": "contract Fomo4D"
																		}
																	},
																	"id": 1329,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "owner",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 1240,
																	"src": "414:14:12",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_external_view$__$returns$_t_string_memory_$",
																		"typeString": "function () view external returns (string memory)"
																	}
																},
																"id": 1330,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "414:16:12",
																"typeDescriptions": {
																	"typeIdentifier": "t_string_memory",
																	"typeString": "string memory"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_string_memory",
																	"typeString": "string memory"
																}
															],
															"id": 1327,
															"name": "keccak256",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2931,
															"src": "404:9:12",
															"typeDescriptions": {
																"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
																"typeString": "function () pure returns (bytes32)"
															}
														},
														"id": 1331,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "404:27:12",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"hexValue": "42696c6c20487375",
																"id": 1333,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "string",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "445:10:12",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_stringliteral_4156829ec8b244eafa6496960410cb08d9ddde0f3f53499a381222d819b4359a",
																	"typeString": "literal_string \"Bill Hsu\""
																},
																"value": "Bill Hsu"
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_stringliteral_4156829ec8b244eafa6496960410cb08d9ddde0f3f53499a381222d819b4359a",
																	"typeString": "literal_string \"Bill Hsu\""
																}
															],
															"id": 1332,
															"name": "keccak256",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2931,
															"src": "435:9:12",
															"typeDescriptions": {
																"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
																"typeString": "function () pure returns (bytes32)"
															}
														},
														"id": 1334,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "435:21:12",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"src": "404:52:12",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseExpression": {
													"argumentTypes": null,
													"hexValue": "66616c7365",
													"id": 1337,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "466:5:12",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "false"
												},
												"id": 1338,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "Conditional",
												"src": "404:67:12",
												"trueExpression": {
													"argumentTypes": null,
													"hexValue": "74727565",
													"id": 1336,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "459:4:12",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "true"
												},
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"id": 1339,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "396:81:12",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 1318,
									"id": 1340,
									"nodeType": "Return",
									"src": "389:88:12"
								}
							]
						},
						"documentation": null,
						"id": 1342,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1315,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1312,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 1342,
									"src": "260:17:12",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1311,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "260:7:12",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1314,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1342,
									"src": "279:15:12",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1313,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "279:7:12",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "259:36:12"
						},
						"payable": false,
						"returnParameters": {
							"id": 1318,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1317,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1342,
									"src": "320:4:12",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1316,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "320:4:12",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "319:6:12"
						},
						"scope": 1343,
						"src": "234:248:12",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 1344,
				"src": "77:407:12"
			}
		],
		"src": "0:485:12"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.801Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Fomo4DFactory.json
// module id = 1038
// module chunks = 0